import { createStore } from 'redux';
import enhancer from './Store';
import { reducers } from '../store/reducers/CombinedReducers';

export const store = createStore(
  reducers,
  enhancer,
);



